import { getLastSignals as apiGetLastSignals } from "@/Groups/Signals/private/api/lastSignals";
import { apiPinSignal } from "@/Groups/Signals/private/api/pinSignal";
import { apiSendSignalToServer, apiSendChangedSignalToServer } from "@/Groups/Signals/private/api/sendSignalToServer"; // Добавьте этот импорт

export const getLastSignals = async ({ commit }) => {
  commit("SET_LOADING_LAST_SIGNALS", true);
  try {
    const data = await apiGetLastSignals();
    commit("SET_LAST_SIGNALS", data);
    commit("SET_READY_LAST_SIGNALS", true);
    return data;
  } catch (err) {
    console.error("Ошибка получения lastSignals:", err);
    throw err;
  } finally {
    commit("SET_LOADING_LAST_SIGNALS", false);
  }
};

export const pinSignal = async ({ commit, state }, { id }) => {
  try {
    const methodType = state.data[id].pinned ? "DELETE" : "POST";
    const data = await apiPinSignal({ id, methodType });
    commit("PIN_SIGNAL", id);
    commit("SORT_SIGNALS");
    return data;
  } catch (err) {
    console.error("Ошибка pin/unpin:", err);
    throw err;
  }
};

export const addSignal = async ({ commit }, formData) => {
  commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", true);
  try {
    const data = await apiSendSignalToServer(formData);
    commit("SET_NEW_SIGNAL", data);
    commit("SORT_SIGNALS");
    commit("UPDATE_DRAFT_FORM", null);
    return data;
  } catch (err) {
    console.error("Ошибка addSignal:", err);
    throw err;
  } finally {
    commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", false);
  }
};

export const changeSignal = async ({ commit, state }, formData) => {
  commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", true);
  try {
    const data = await apiSendChangedSignalToServer(formData, state.idEditSignal);
    commit("UPDATE_SIGNAL", data);
    return data;
  } catch (err) {
    console.error("Ошибка changeSignal:", err);
    throw err;
  } finally {
    commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", false);
  }
};

export const updateTrendingSignals = ({ commit, state }, data) => {
  data.forEach((item) => {
    if (state.map.includes(item.id)) {
      commit("MAKE_SIGNAL_TRENDING", { id: item.id, status: true });
    } else {
      commit("SET_NEW_SIGNAL", item);
    }
  });
  commit("SORT_SIGNALS");
};

export const saveDraftForm = async ({ commit }, data) => {
  commit("UPDATE_DRAFT_FORM", data);
};

export const approveLiveStatus = async ({ commit }, id) => {
  commit("CHANGE_LIVE_STATUS", { id, status: true });
};

export const updateIdEditSignal = async ({ commit }, id) => {
  commit("CHANGE_ID_EDIT_SIGNAL", id);
};